import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { Theme } from '@radix-ui/themes';
import { ThemeProvider } from 'next-themes';
import App from './App.tsx';
import '@radix-ui/themes/styles.css';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <Theme 
          accentColor="blue" 
          grayColor="slate" 
          radius="medium" 
          scaling="100%" 
          appearance="dark"
        >
          <App />
        </Theme>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>
);